import { CreateTicketComponent } from './create/create-ticket.component';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { TicketsComponent } from './list/tickets.component';
import { TicketComponent } from './single/ticket.component';
import { RouterModule } from '@angular/router';
import { TicketService } from './ticket.service';
import { PrintComponent } from './print/print.component';
import { IsLoggedInService } from '../auth/isLoggedIn.service';
import { ChangeFlightComponent } from './change-flight/change-flight.component';
import { SingleComponent } from './print/single/single.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: 'tickets',
        component: TicketsComponent,
        canActivate: [IsLoggedInService]
      },
      {
        path: 'tickets/print/:lang/:ids',
        component: PrintComponent,
        canActivate: [IsLoggedInService]
      }
    ])
  ],
  declarations: [
    TicketsComponent,
    TicketComponent,
    CreateTicketComponent,
    PrintComponent,
    ChangeFlightComponent,
    SingleComponent
  ],
  entryComponents: [CreateTicketComponent, ChangeFlightComponent],
  providers: [TicketService]
})
export class TicketsModule {}



// WEBPACK FOOTER //
// ./src/app/tickets/tickets.module.ts